module.exports = __webpack_public_path__ + "static/media/psurvey_manual.05d3a2b9.pdf";